import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card'
import { formatDateTime } from '@/lib/format'
import type { AlertResolution, Resolution } from '../../types'

const RESOLUTION_LABEL: Record<Resolution, string> = {
  false_positive: 'False positive',
  fraud_confirmed: 'Fraud confirmed',
  insufficient_evidence: 'Closed (other)',
  duplicate: 'Duplicate',
  customer_confirmed_legitimate: 'Customer confirmed legitimate',
  other: 'Other',
}

/**
 * Close audit for a closed alert: outcome, who closed it, when, and the
 * analyst's stated reason. `resolution` mirrors `AlertResolutionView`
 * (internal/api/alerts_handler.go); `by` is null when the closer is unknown
 * and `reason` is "" when none was recorded - both are stated explicitly
 * rather than hidden.
 */
export function ResolutionAudit({ resolution }: { resolution: AlertResolution }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Close audit</CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="grid grid-cols-[max-content_1fr] gap-x-4 gap-y-1 text-sm">
          <dt className="text-muted-fg">Outcome</dt>
          <dd className="font-medium">{RESOLUTION_LABEL[resolution.resolution]}</dd>
          <dt className="text-muted-fg">Closed by</dt>
          <dd>{resolution.by ? resolution.by.display_name : 'Not recorded'}</dd>
          <dt className="text-muted-fg">Closed at</dt>
          <dd>{formatDateTime(resolution.at)}</dd>
          <dt className="text-muted-fg">Reason</dt>
          <dd className="whitespace-pre-wrap break-words">
            {resolution.reason.trim() !== '' ? resolution.reason : 'No reason recorded'}
          </dd>
        </dl>
      </CardContent>
    </Card>
  )
}
